import type { IperiaGroup, IperiaGroupRegistration } from '../types/iperiaStatus'

/**
 * Chemin SPA du dossier suivant. On n'utilise pas `public_url` (`…/verification`) : le gate
 * autorise cette étape même quand le dossier est plus avancé, donc l'AM rejouerait le parcours.
 * L'index `/iperia/:id` redirige vers l'étape réellement due.
 */
export function nextLotPath(next: IperiaGroupRegistration | null | undefined): string | null {
  return next?.global_id ? `/iperia/${next.global_id}` : null
}

export function remainingUnsignedSiblings(group: IperiaGroup): number {
  return group.registrations.filter((registration) => !registration.is_current && !registration.learner_signed).length
}
